import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { CHANNELS } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import ListingChipsList from '@spotahome/ui-library/src/tenant/components/ListingChipsList';
import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import RnaId from '../RnaId';

import './ListingValuePropositionModal.scss';

const openListingValuePropositionModal = ({
  chipList = [],
  landlordDescription = '',
  listingDescription = '',
  roomDescription = '',
  rnaIdFeature = null,
  fullscreenOnMobile = false
} = {}) => {
  const propertyChips = chipList.filter(chip => !chip.isGuarantee);
  const guaranteeChips = chipList.filter(chip => chip.isGuarantee);

  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.value.proposition.title'),
    body: (
      <>
        {propertyChips.length > 0 && (
          <div className="listing-value-proposition-modal__section listing-value-proposition-modal__section-chips-list">
            <ListingTitle role="tertiary">
              {trans('value.proposition.features.title')}
            </ListingTitle>
            <ListingChipsList chipList={propertyChips} />
          </div>
        )}
        {guaranteeChips.length > 0 && (
          <div className="listing-value-proposition-modal__section listing-value-proposition-modal__section-chips-list">
            <ListingTitle role="tertiary">
              {trans('value.proposition.features.title.always')}
            </ListingTitle>
            <ListingChipsList chipList={guaranteeChips} />
          </div>
        )}
        {landlordDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.landlord.description.title')}
            </ListingTitle>
            <ListingContent content={landlordDescription} />
          </div>
        )}
        {listingDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.description.title')}
            </ListingTitle>
            <ListingContent content={listingDescription} />
          </div>
        )}
        {roomDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.room_description')}
            </ListingTitle>
            <ListingContent content={roomDescription} />
          </div>
        )}
        {rnaIdFeature && rnaIdFeature?.value !== 'no' && (
          <RnaId
            className="listing-value-proposition-modal__section listing-value-proposition-modal__section-rna-id-content"
            rnaIdFeature={rnaIdFeature}
          />
        )}
      </>
    ),
    fullscreenOnMobile
  });
};

export default openListingValuePropositionModal;
